import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import styles from './index.module.scss';
import { CustomFormControl } from 'components/Form/FormControl';
import Loader from 'components/Loaders/Loader';
import { TextButton } from 'components/Buttons/TextButton';
import { useNavigate } from 'react-router-dom';

export interface StepReadyToSubmitProps {
  className?: string;
  driver: any;
  onSubmit: (fullName: string, alphaCode: string) => void;
}

export interface SubmitChecklistForm {
  fullname?: string;
  alphaCode?: string;
}

function StepReadyToSubmit(props: StepReadyToSubmitProps) {
  const navigate = useNavigate();
  const onSubmit = () => {
    props.onSubmit(props.driver.fullName, props.driver.employeeId);
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (!props.driver) return <Loader />;

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>Ready to submit?</h2>
      <p className={styles.question}>
        I hereby certify that all information on this form is correct and
        complete to the best of my knowledge. I authorize the individual or
        clinic that performed my DOT physical to release my DOT Medical
        Certificate and any other information that may be used to determine my
        ability to safely operate a tractor-trailer to Carrier and to any
        physician Carrier may choose to review my job qualifications. I
        understand that this form and other information gathered will be used
        for determining my ability to operate a commercial motor vehicle safely
        as required by the Federal Motor Carrier Safety Act. I understand that
        any false information or misrepresentations made by me will result in
        denial of my driver application or termination of my employment or
        contract with Carrier, as applicable. If I am an employee driver, I
        understand that providing false information or misrepresentations will
        result in loss of any workers’ compensation benefits to which I might
        otherwise be entitled (as permitted by law) if a condition I fail to
        report results in an injury or the condition is aggravated. I further
        certify that I have received information concerning Medical
        Qualification contained in the Federal Motor Carrier Safety Regulations,
        including Parts 391.41 and 391.47.
      </p>

      <div className={styles.form}>
        <CustomFormControl
          label={'Name'}
          inputProps={{
            value: props.driver?.fullName,
            readOnly: true,
          }}
        />

        <CustomFormControl
          label={'Alpha Code'}
          inputProps={{
            value: props.driver?.employeeId,
            readOnly: true,
          }}
        />

        <div>
          <ButtonWithArrowIcon
            onClick={onSubmit}
            variant="contained"
            color="primary"
          >
            Submit
          </ButtonWithArrowIcon>
          <TextButton onClick={handleBack}>Go Back</TextButton>
        </div>
      </div>
    </div>
  );
}

export default StepReadyToSubmit;
